import style from './brand.module.less';


export default function Brand(
	{
		logoSize = "2rem",
		fontSize = "1.5rem"
	}) {
	return (
		<a href="/" style={{textDecoration: "none"}}>
			<div className={style.brand}>
				<img src={"https://xinsulv-adsurgebot-test.oss-cn-hongkong.aliyuncs.com/front/logo.png"}
						 alt={"logo"}
						 className={style.brandLogo}
						 style={{width: logoSize}}
				/>
				<span
					className={style.brandText}
					style={{fontSize: fontSize}}
				>
					AdSurgebot
				</span>
			</div>
		</a>
	);
}
